"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { TagsModel } from "@/models/tags.model";
export let CoreProductItemModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.parent_id = null;
    this.parent_type = null;
    this.name = "";
    this.sort = 0;
    this.marks = new TagsModel();
    this.info_tags = [null, null];
    this.tips = null;
    this.image_style = null;
  }
};
CoreProductItemModel.model = "region.core";
CoreProductItemModel = __decorateClass([
  Annotation.ModelMeta
], CoreProductItemModel);
export let CategoryInfoModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.types = null;
    this.regions = null;
    this.areas = null;
    this.remotes = null;
    this.models = null;
  }
};
CategoryInfoModel.model = "region.category.info";
CategoryInfoModel = __decorateClass([
  Annotation.ModelMeta
], CategoryInfoModel);
export let CategoryTypeModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.types = [];
    this.regions = [];
    this.areas = [];
    this.remotes = [];
    this.models = [];
  }
};
CategoryTypeModel.model = "region.category";
CategoryTypeModel = __decorateClass([
  Annotation.ModelMeta
], CategoryTypeModel);
export let NewCategoryTypeModel = class extends CoreProductItemModel {
};
NewCategoryTypeModel.model = "region.top_category_type";
NewCategoryTypeModel = __decorateClass([
  Annotation.ModelMeta
], NewCategoryTypeModel);
export let NewCategoryRegionModel = class extends CoreProductItemModel {
};
NewCategoryRegionModel.model = "region.top_category_region";
NewCategoryRegionModel = __decorateClass([
  Annotation.ModelMeta
], NewCategoryRegionModel);
export let NewCategoryAreaModel = class extends CoreProductItemModel {
};
NewCategoryAreaModel.model = "region.top_category_area";
NewCategoryAreaModel = __decorateClass([
  Annotation.ModelMeta
], NewCategoryAreaModel);
export let NewCategoryRemotesModel = class extends CoreProductItemModel {
};
NewCategoryRemotesModel.model = "region.top_category_remote";
NewCategoryRemotesModel = __decorateClass([
  Annotation.ModelMeta
], NewCategoryRemotesModel);
export let NewCategoryModelsModel = class extends CoreProductItemModel {
};
NewCategoryModelsModel.model = "region.top_category_model";
NewCategoryModelsModel = __decorateClass([
  Annotation.ModelMeta
], NewCategoryModelsModel);
